import { defineMessages, FormattedMessage } from 'react-intl';
export const countrySelectorMessages = defineMessages({
  internationalLocation: {
    id: `international.location`,
    defaultMessage: 'Location',
  },
  internationalLanguage: {
    id: `international.language`,
    defaultMessage: 'Language',
  },
  internationalCta: {
    id: `international.cta`,
    defaultMessage: 'Continue',
  },
});

export const InternationalHeaderMobile = () => (
  <FormattedMessage
    defaultMessage='Choose Your Country{br}And Language'
    id='international.header.mobile'
    values={{
      br: <br />,
    }}
  />
);
